const teamPageEN = {
	header: {
		title: "Team",
		inviteStaff: "Invite staff",
		manageStaff: "Manage staff",
	},
	messages: {
		activateFailed: "Failed to activate staff profile.",
		noValidEmail: "Please enter at least one valid email.",
		inviteFailed: "Failed to send some invites.",
		removeFailed: "Failed to remove staff. Please try again.",
		removeSuccess: "{{name}} removed successfully.",
		promoteFailed: "Failed to promote.",
		demoteFailed: "Failed to demote.",
		reinviteFailed: "Failed to resend invite.",
	},
	confirm: {
		removeStaff: "Remove this staff member?",
		popupTitle: "Remove {{name}}?",
		popupSubtitle: "This action cannot be undone.",
		cancelInviteTitle: "Cancel invite for {{name}}?",
		cancelInviteSubtitle: "The staff member will no longer be able to join.",
		cancel: "Cancel",
		confirm: "Confirm",
		warningBookings: "Please review this staff member’s upcoming bookings and reassign them if needed. If the staff member is removed, all active appointments in their calendar will be automatically canceled. Are you sure you want to proceed?",
	},
	status: {
		active: "Active",
		registered: "Registered",
		invited: "Invited",
		joined: "Registered",
	},
	main: {
		services: "Services",
		noServices: "No services assigned",
		launch: "Launch",
		active: "Active",
		inactive: "Inactive",
		homeService: "Home service",
	},
	labels: {
		email: "Email:",
		phone: "Phone:",
		firstName: "First name",
		lastName: "Last name",
		emailAddress: "Email address",
	},
	actions: {
		addStaff: "+ Add Staff",
		saveClose: "Save & Close",
		sending: "Sending...",
		removing: "Removing...",
		cancel: "Cancel",
		confirm: "Confirm",
		removing: "Removing...",
		promoteToAdmin: "Promote to Admin",
		demoteToStaff: "Demote to Staff",
		reinvite: "Re-invite",
		cancelInvite: "Cancel Invite",
	},

	role: {
		owner: "Owner",
		admin: "Admin",
	},
	toast: {
		promotedToAdmin: "{{name}} is now an admin.",
		demotedToStaff: "{{name}} was demoted to staff.",
		inviteResent: "Invitation sent again.",
		inviteCancelled: "Invite cancelled for {{name}}",
	},
};
export default teamPageEN;
